import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { useConvertToModule } from "./anthologyServices";
import withAuthorization from "../../auth/withAuthorization";
import { useHistory } from "react-router-dom";
import { useAlert } from "../organize/OrganizeProvider";

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.brandPrimary,
  },
  loader: {
    position: "absolute",
  },
}));

const ConvertToModule = ({ id }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const history = useHistory()
  const alert = useAlert();
  const convertToModule = useConvertToModule();
  const isLoading = convertToModule.isLoading;

  const handleCancel = () => {
    if (!isLoading) setOpen(false);
  };

  const handleConfirm = async () => {
    try {
      const module = await convertToModule.mutateAsync({ resourceIds: { id } });
      setOpen(false);
      history.push(`/creator/organize?view=organize,organize-grouped,module&id=${module.id}`);
    } catch (error) {
      setOpen(false);
      alert.show("error", [error?.message ?? "Failed to convert anthology to module."]);
    }
  };

  return (
    <Fragment>
      <Tooltip title="Convert to Module">
        <IconButton onClick={() => setOpen(true)}>
          <FontAwesomeIcon icon={faArrowRightArrowLeft} />
        </IconButton>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleCancel}
        disableBackdropClick={isLoading}
        disableEscapeKeyDown={isLoading}
        maxWidth="xs"
      >
        <DialogTitle disableTypography>
          <Typography classes={{ root: classes.title }}>
            Convert to Module
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Would you like to convert this anthology into a module?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancel}
            disabled={isLoading}
            style={{ fontWeight: 400 }}
            autoFocus
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isLoading}
            color="primary"
            variant="contained"
            style={{ position: "relative" }}
          >
            {isLoading && (
              <CircularProgress size={20} classes={{ root: classes.loader }} />
            )}
            Convert
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default withAuthorization(ConvertToModule, false);
